var divider_viewer_rtlignore_default = {
  "divider-container": "t-kgM",
  "divider-container--double": "t2YWj",
  "divider": "_7-UdU",
  "divider--single": "_8YrGD",
  "divider--double": "yvsYq",
  "divider--dashed": "KD9hA",
  "divider--dotted": "b7iQw",
  "divider--small": "QLlT5",
  "divider--small--mobile": "H1-w6",
  "divider--medium": "nPiDZ",
  "divider--large--mobile": "fUz2R",
  "divider--medium--mobile": "wANP0",
  "divider--large": "raiVK",
  "divider--left": "YhTee",
  "divider--center": "EKdER",
  "divider--right": "fYcj9",
  "divider--fill-parent": "mESxt",
  "svgFixerContainer": "Ipkp5",
  "emptyChar": "_0Btb9"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
